(function(){
  angular.module("irricrops")
    //constantes generales
    .constant("TUTORIAL_DIC",{
      TEST:[
          {
            image       : 'http://i.imgur.com/W81H0Fz.gif',
            title       : "titulo",
            description : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          },
          {
            image       : 'http://i.imgur.com/olstrNn.gif',
            title       : "titulo2",
            description : 'Pellentesque sed elit at velit egestas sodales sit amet at sapien. Maecenas ut facilisis ligula, vitae lobortis ipsum. Quisque quis ultrices tellus, nec porta ligula. Nullam ac diam condimentum, bibendum quam a, malesuada orci. Donec ante mi, tempor vitae maximus eu, rutrum sit amet enim. Donec eleifend ipsum a tincidunt facilisis. Praesent ut turpis enim. Sed vitae ipsum vel risus efficitur lobortis quis vitae nunc. In quis sodales ipsum. Nam lobortis felis a iaculis malesuada. Pellentesque ullamcorper fermentum ligula, ut pulvinar massa eleifend non. Sed ac nisi et massa condimentum tincidunt. Cras iaculis, enim vel tincidunt posuere, leo tellus molestie nisi, lobortis scelerisque leo massa eu purus. Ut pharetra augue et viverra scelerisque.'
          }
      ]
    });

})();
